<div class="address-selector">
  <app-auto-complete #addressSearch (addressChanged)="setAddress($event)" *ngIf="!address"></app-auto-complete>

  <div *ngIf="address" class="address-selector__view">
    <app-view-address [address]="address" [disabled]="disabled" (propertyChanged)="setAddress($event.address)">
    </app-view-address>

    <div class="summary__buttons">
      <a href="javascript:void(0);" (click)="reset()">Search Again</a>
      <a href="javascript:void(0)" (click)="manual()">Enter Manually</a>
    </div>
  </div>
</div>
